<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7752_2158)">
<path d="M4.16521 16.0001H0.859509V5.31798H4.16521V16.0001ZM2.51058 3.86084C1.45375 3.86084 0.596191 2.98227 0.596191 1.92155C0.596191 0.860837 1.45375 0.00012207 2.51058 0.00012207C3.56741 0.00012207 4.42497 0.860837 4.42497 1.92155C4.42497 2.98227 3.56741 3.86084 2.51058 3.86084ZM16.5376 16.0001H13.239V10.8001C13.239 9.56084 13.2141 7.97155 11.5203 7.97155C9.80163 7.97155 9.53831 9.31798 9.53831 10.7108V16.0001H6.23617V5.31798H9.40665V6.77512H9.45291C9.89414 5.93584 10.9723 5.05012 12.5807 5.05012C15.9255 5.05012 16.5411 7.26084 16.5411 10.1323V16.0001H16.5376Z"/>
</g>
<defs>
<clipPath id="clip0_7752_2158">
<rect width="16" height="16" fill="white" transform="translate(0.596191 0.00012207)"/>
</clipPath>
</defs>
</svg>
